// メインアプリケーションコンポーネント

import React, { useEffect, useState } from 'react';
import { RouterProvider } from 'react-router-dom';
import { router } from './router';
import { AIQuotaProvider, useAIQuota } from './hooks/useAIQuota';
import QuotaExceededDialog from './components/QuotaExceededDialog';

const AppContent: React.FC = () => {
  const { quotaInfo, resetDate, refreshQuota } = useAIQuota();
  const [showQuotaDialog, setShowQuotaDialog] = useState(false);

  useEffect(() => {
    const handleQuotaExceeded = (event: Event) => {
      console.log('AI quota exceeded event received:', event);
      setShowQuotaDialog(true);
      // クォータ情報を更新
      refreshQuota().catch(console.error);
    };

    window.addEventListener('ai-quota-exceeded', handleQuotaExceeded);
    console.log('AI quota exceeded event listener registered');

    return () => {
      window.removeEventListener('ai-quota-exceeded', handleQuotaExceeded);
    };
  }, [refreshQuota]);

  return (
    <>
      <div className="App">
        <RouterProvider router={router} />
      </div>
      <QuotaExceededDialog
        isOpen={showQuotaDialog}
        onClose={() => setShowQuotaDialog(false)}
        quotaInfo={quotaInfo}
        resetDate={resetDate}
      />
    </>
  );
};

const App: React.FC = () => {
  return (
    <AIQuotaProvider>
      <AppContent />
    </AIQuotaProvider>
  );
};

export default App;